function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var ShopFilled = function ShopFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: props.size > 16 ? 0 : 0.8,
    stroke: props.size <= 16 ? props.color ? props.color : "#242328" : "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    d: "M7.26 6.25h-.274a2.75 2.75 0 0 0-2.74 2.526l-.817 10a2.75 2.75 0 0 0 2.74 2.974H17.83a2.75 2.75 0 0 0 2.74-2.974l-.815-10a2.75 2.75 0 0 0-2.741-2.526h-.268c-.048-1.535-.537-2.774-1.378-3.646C14.482 1.686 13.277 1.25 12 1.25c-1.305 0-2.486.502-3.347 1.436-.815.883-1.305 2.11-1.392 3.564m1.504 0h6.481c-.046-1.214-.43-2.059-.956-2.604-.562-.582-1.356-.896-2.289-.896-.905 0-1.68.34-2.245.953-.527.572-.907 1.422-.991 2.547",
    clipRule: "evenodd"
  }));
};
export default ShopFilled;
ShopFilled.displayName = 'ShopFilled';